import { BaseModel } from "../base.model";

export function translatableDeserializer<T extends BaseModel = BaseModel>(Cls: typeof BaseModel): (data: Record<string, object>) => Record<string, T> {
  return (data: Record<string, object>) => Object.fromEntries(
    Object.entries(data).map(([langKey, pageData]) => [langKey, Cls.fromServer(pageData) as T])
  );
}